import React, { FC } from 'react'
import { IChatBoxProps } from './models'

const FakeChatBox: FC<IChatBoxProps> = () => {
  return null
}

const ChatBoxRemote = await import('tasktracker/ChatBox')
  .then(res => res.ChatBox || FakeChatBox)
  .catch(() => FakeChatBox)

export const ChatBox = (props: IChatBoxProps) => {
  return <ChatBoxRemote {...props} id="PlatformChatBox" />
}
